import React from 'react';
import '../../styles/preloader.css';

const Preloader = () => {
  return (
    <div className="preloader-container">
      <div className="preloader"></div>
    </div>
  );
};

export default Preloader;
